import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBIcon,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";

const GoldPlanCard = ({ width }) => {
  return (
    <MDBCard
      className={
        width > 767
          ? "border-dark pelvic-sense-cards h-100 position-relative"
          : "border-dark pelvic-sense-cards h-100"
      }
    >
      <MDBCardBody>
        <MDBCardTitle className="text-al text-center fs-banner-7-cards-title-32-24">
          Gold
        </MDBCardTitle>
        <MDBCardText>
          <p className="text-center text-dm fs-16">$97/month</p>
          <div className="d-flex align-items-start">
            <div className={width > 600 ? "p-0 pe-3 pb-2 pt-1 mt-1": "p-0 pe-3 pb-2 mt-1"}>
              <div className="circle-dot dot-icon-margin"></div>
            </div>
            <p className="text-dm text-black fs-banner-7-cards-text-16-12 m-0">
              One private 30 min Zoom session with Evelyn Hecht, PT
            </p>
          </div>
          <div className="d-flex align-items-start">
            <div className={width > 600 ? "p-0 pe-3 pb-2 pt-1 mt-1": "p-0 pe-3 pb-2 mt-1"}>
              <div className="circle-dot dot-icon-margin"></div>
            </div>
            <p className="text-dm text-black fs-banner-7-cards-text-16-12 m-0">
              Max of 6 Group Zoom meets with Evelyn & active members Wednesday's
              @ 1pm EST
            </p>
          </div>
          <div className="d-flex align-items-start">
            <div className={width > 600 ? "p-0 pe-3 pb-2 pt-1 mt-1": "p-0 pe-3 pb-2 mt-1"}>
              <div className="circle-dot dot-icon-margin"></div>
            </div>
            <p className="text-dm text-black fs-banner-7-cards-text-16-12 m-0">
              Ability to download all 11 Rewire calming audio guides
            </p>
          </div>
          <div className="d-flex align-items-start">
            <div className={width > 600 ? "p-0 pe-3 pb-2 pt-1 mt-1": "p-0 pe-3 pb-2 mt-1"}>
              <div className="circle-dot dot-icon-margin"></div>
            </div>
            <p className="text-dm text-black fs-banner-7-cards-text-16-12 m-0">
              Full Online Program
            </p>
          </div>
          <div className="d-flex align-items-start">
            <div className={width > 600 ? "p-0 pe-3 pb-2 pt-1 mt-1": "p-0 pe-3 pb-2 mt-1"}>
              <div className="circle-dot dot-icon-margin"></div>
            </div>
            <p className="text-dm text-black fs-banner-7-cards-text-16-12 m-0">
              Email support from Evelyn Hecht, PT
            </p>
          </div>
          <div className="d-flex align-items-start">
            <div className={width > 600 ? "p-0 pe-3 pb-2 pt-1 mt-1": "p-0 pe-3 pb-2 mt-1"}>
              <div className="circle-dot dot-icon-margin"></div>
            </div>
            <p className="text-dm text-black fs-banner-7-cards-text-16-12 m-0">
              Invite to Private FB Group
            </p>
          </div>
          <div className="d-flex align-items-start">
            <div className={width > 600 ? "p-0 pe-3 pb-2 pt-1 mt-1": "p-0 pe-3 pb-2 mt-1"}>
              <div className="circle-dot dot-icon-margin"></div>
            </div>
            <p className="text-dm text-black fs-banner-7-cards-text-16-12 m-0">
              Access to PelvicSense Mobile
            </p>
          </div>
          <div className="d-flex align-items-start">
            <div className={width > 600 ? "p-0 pe-3 pb-2 pt-1 mt-1": "p-0 pe-3 pb-2 mt-1"}>
              <div className="circle-dot dot-icon-margin"></div>
            </div>
            <p className="text-dm text-black fs-banner-7-cards-text-16-12 m-0">
              10% discount for the first month through Elana
            </p>
          </div>
        </MDBCardText>
        <div
          className={
            width > 767 ? "position-absolute bottom-0 start-50 translate-middle-x w-100 pelvic-button-div": "pelvic-button-div"
          }
        >
          <Link to="/pelvicSenseEmail">
            <button className="btn btn-primary w-100 py-3 card-button border-0">
              LET'S GO!
            </button>
          </Link>
        </div>
      </MDBCardBody>
    </MDBCard>
  );
};

export default GoldPlanCard;
